module.exports = __webpack_public_path__ + "static/media/n_icon_dynameic@2x.0c4f4841.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_dynameic@2x.png
// module id = 668
// module chunks = 0 1